// Shared "group by session/campus/course" helper for attendance & meals
// history tables, used identically on the admin and hostel-portal sides.
// Grouping is purely a display option — "No grouping" (the flat list that
// already existed) stays available and is still the default.
export const GROUP_OPTIONS = [
  { value: '', label: 'No grouping (flat list)' },
  { value: 'campus', label: 'Group by Campus' },
  { value: 'course', label: 'Group by Course' },
  { value: 'session', label: 'Group by Batch / Program (session)' },
];

// rows: any array with an admission_id field (roster rows or history rows)
// admissionsById: { [id]: { campus_id, course_id, dept_batch_program, ... } }
// campusNameById / courseNameById: { [id]: name }
export function groupRows(rows, groupBy, admissionsById, campusNameById, courseNameById) {
  if (!groupBy) return [{ label: null, rows }];
  const buckets = new Map();
  for (const row of rows) {
    const adm = admissionsById?.[row.admission_id] || {};
    let label;
    if (groupBy === 'campus') label = campusNameById?.[adm.campus_id] || 'Unassigned Campus';
    else if (groupBy === 'course') label = courseNameById?.[adm.course_id] || 'Unassigned Course';
    else label = adm.dept_batch_program || 'Unassigned Batch';
    if (!buckets.has(label)) buckets.set(label, []);
    buckets.get(label).push(row);
  }
  return Array.from(buckets.entries())
    .sort((a, b) => a[0].localeCompare(b[0]))
    .map(([label, rows]) => ({ label, rows }));
}
